import React, { createContext, useContext } from "react";

const LayoutContext = createContext({
    toggleSidebar: () => {},
    sidebarOpen: false,
});

export const LayoutProvider = ({ children, toggleSidebar, sidebarOpen }) => {
    return (
        <LayoutContext.Provider value={{ toggleSidebar, sidebarOpen }}>
            {children}
        </LayoutContext.Provider>
    );
};

export const useLayout = () => {
    const context = useContext(LayoutContext);
    if (!context) {
        throw new Error("useLayout must be used within a LayoutProvider");
    }
    return context;
};
